export default "__VITE_ASSET__4187f1f0__"